/* reactとreact-domの読み込み */
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import thunk from 'redux-thunk';
import {Paper, TextField, Button, Typography, CssBaseline, Icon, Avatar, CircularProgress, LinearProgress, Fade} from '@material-ui/core';
import {Action, createStore, applyMiddleware, Middleware} from 'redux'
import {Provider, connect} from 'react-redux';
import {SystemLoginState, loginReducer, asyncLoginAction} from "./reducers/LoginReducers";
import * as LoginActions from './actions/LoginActions';
import { PdLoadingDialog } from './component/PdLoadingDialog';


interface IndexProps extends React.Props<any> {
	state:SystemLoginState,
}

export class _LoginBox extends React.Component<IndexProps, {}>{
	constructor(props:IndexProps){
		super(props);
	}

	onClockLogin(login:SystemLoginState){
		store.dispatch(asyncLoginAction(login));
	}

	onChangeUserId(val:string){
		store.dispatch(LoginActions.actionLoginOnChangeUserId(val));
	}

	onChangePassword(val:string){
		store.dispatch(LoginActions.actionLoginOnChangePassword(val));
	}

	render(){
		return(
			<div className="login_container">
				<CssBaseline />
				<Paper className="login_wrapper" elevation={4}>
					<div style={{display: 'flex', justifyContent: 'center', marginBottom: '30px'}}><Avatar style={{backgroundColor: '#EC407A'}}><Icon>lock</Icon></Avatar></div>
					<Typography variant="title" gutterBottom className="aligncenter">コントロールパネル</Typography>
					<form className="login_form" noValidate>
						<TextField id="userid" label="ユーザーID" className="userid" type="email" value={this.props.state.userId} onChange={(e) => {this.onChangeUserId(e.target.value)}} placeholder="ユーザーIDを入力" margin="normal" fullWidth InputLabelProps={{shrink: true,}} disabled={this.props.state.isLoading} />
						<TextField id="password" label="パスワード" className="password" type="password" value={this.props.state.password} onChange={(e) => {this.onChangePassword(e.target.value)}} placeholder="パスワードを入力" autoComplete="current-password" margin="normal" fullWidth InputLabelProps={{shrink: true,}} disabled={this.props.state.isLoading} />
						<p><Button variant="raised" color="primary" className="login_button" onClick={()=>{this.onClockLogin(this.props.state)}} disabled={this.props.state.isLoading}>ログイン</Button></p>
					</form>
					<div className="errorbox">
						{(this.props.state.errorMsg.length > 0) ? <p>{this.props.state.errorMsg}</p>: ''}
					</div>
				</Paper>
				<Fade in={this.props.state.isLoading}><LinearProgress color="secondary" /></Fade>
			</div>
		);
	}
}
function mapStateToProps(state:SystemLoginState) {
	return {
		state: state
	}
}
const LoginBox = connect(mapStateToProps)(_LoginBox);


const store = createStore(loginReducer, applyMiddleware(thunk));
ReactDOM.render(
	<Provider store={store}>
		<LoginBox />
	</Provider>,
	document.querySelector('#app')
);